import {
  USERLOCALPERMISSIONS_SET,
  USERALLDATABASESPERMISSIONS_SET,
  PERMISSIONS_EDITED,
  PERMISSIONS_SET,
  USERROLEPERMISSIONS_ADDED,
  USERROLEPERMISSIONS_DELETED,
  USERROLEPERMISSIONS_EDITED,
  USERROLEPERMISSIONS_SET,
} from 'src/app/redux/redux-types';
import { reduxUserRolePermissionsTypes } from 'src/types';
import { PermissionsResultType } from 'src/types/services/permission-service.type';
import {
  UserRolePermissionCreateDataType,
  UserRolePermissionCreateResultType,
  UserRolePermissionResultType,
} from 'src/types/services/userRolePermission-service.type';

export const permissionList = (list: PermissionsResultType[]) => {
  return {
    type: PERMISSIONS_SET,
    payload: list,
  };
};

export const userRolePermissionList = (list: UserRolePermissionResultType[]) => {
  return {
    type: USERROLEPERMISSIONS_SET,
    payload: list,
  };
};

export const userLocalPermissionList = (list: number[]) => {
  return {
    type: USERLOCALPERMISSIONS_SET,
    payload: list,
  };
};

export const userAllDatabasesPermissionList = (list: number[]) => {
  return {
    type: USERALLDATABASESPERMISSIONS_SET,
    payload: list,
  };
};

export const userRolePermissionEdited = (payload: UserRolePermissionResultType[]) => {
  return {
    type: USERROLEPERMISSIONS_EDITED,
    payload,
  };
};

export const userRolePermissionAdded = (payload: UserRolePermissionCreateResultType[]) => {
  return {
    type: USERROLEPERMISSIONS_ADDED,
    payload,
  };
};

export const userRolePermissionDeleted = (payload: string) => {
  return {
    type: USERROLEPERMISSIONS_DELETED,
    payload,
  };
};
